import { Col, Row } from "antd";
import { TScheduleMode } from "@components/schedule/common/scheduleMode";
import { ScheduleTypeRow, TScheduleType } from "./scheduleTypeRow";
import { TSchedule, TScheduleTemplate } from "@components/schedule/common/types";
import { ScheduleTypeIntervalSettings } from "./scheduleTypeIntervalSettings";
import { ScheduleTimeRow } from "./scheduleTimeRow";
import { ScheduleBreaks } from "./scheduleBreaks";

type TProps = {
    editing: boolean; 
    schedule?: TSchedule | TScheduleTemplate;
    scheduleTypes: TScheduleType[];
    scheduleMode: TScheduleMode;
    onScheduleTypeChange: (option: TScheduleType | TScheduleType[]) => void;
    onStartDateChange: (value: moment.Moment) => void;
    setScheduleIntervalOnDays: (value: number) => void;
    setScheduleIntervalOffDays: (value: number) => void;
    onScheduleTimeChange: (value: string, target: 'start_time' | 'end_time') => void;
    onBreakDelete: (index: number) => void;
    tempBrake: { start_break_time?: Date, end_break_time?: Date };
    onTempBrakeChange: (val: Date | null, target: 'start_break_time' | 'end_break_time') => void;
    tryAddBreak: (index: number, dates: moment.Moment[]) => void;
    intOn: number;
    intOff: number;
};

const ScheduleSettingsPanel = ({
    editing,
    schedule,
    scheduleTypes,
    scheduleMode,
    onScheduleTypeChange,
    onStartDateChange,
    setScheduleIntervalOnDays,
    setScheduleIntervalOffDays,
    onScheduleTimeChange,
    onBreakDelete,
    tempBrake,
    onTempBrakeChange,
    tryAddBreak,
    intOn,
    intOff
}: TProps): JSX.Element => {
    return (
        <>
            <ScheduleTypeRow 
                editing={editing}
                scheduleTypes={scheduleTypes}
                scheduleMode={scheduleMode}
                schedule={schedule}
                onScheduleTypeChange={onScheduleTypeChange}
                onStartDateChange={onStartDateChange}
            />
            {scheduleMode === 'interval' && (
                <ScheduleTypeIntervalSettings 
                    editing={editing}
                    setScheduleIntervalOnDays={setScheduleIntervalOnDays}
                    setScheduleIntervalOffDays={setScheduleIntervalOffDays}
                    intOff={intOff}
                    intOn={intOn}
                />
            )}
            <ScheduleTimeRow 
                editing={editing}
                scheduleTime={{ 
                    start_time: schedule?.start_time, 
                    end_time: schedule?.end_time 
                }}
                onScheduleTimeChange={onScheduleTimeChange}
            />
            <ScheduleBreaks
                editing={editing}
                breaks={schedule?.breaks}
                onBreakDelete={onBreakDelete}
                tempBreak={tempBrake}
                onTempBreakChange={onTempBrakeChange}
                tryAddBreak={tryAddBreak}
            />
            {(schedule as TScheduleTemplate)?.schedules !== undefined && (
                <Row>
                    <Col className="half-width">
                        <Row>
                            <label>По этому шаблону работают</label>
                            <i className="hpadded">
                                {(schedule as TScheduleTemplate)?.schedules.length} человек(а)
                            </i>
                        </Row>
                    </Col>
                </Row>
            )}
        </>
    );
};

export { ScheduleSettingsPanel };